import classNames from 'classnames';
import React, { useState } from 'react';
import styles from './cursor.module.scss';

class Mouse {
  constructor(public x: number = 0, public y: number = 0) {}

  setPosition(x: number, y: number): void {
    this.x = x;
    this.y = y;
  }
}

class Ball {
  constructor(
    private _speed: number,
    public x: number,
    public y: number,
  ) {}

  update(mouse: Mouse): void {
    let dx = (mouse.x - this.x) * .123;
    let dy = (mouse.y - this.y) * .123;
    const distance = Math.sqrt(dx * dx + dy * dy);

    if(distance > this._speed){
      dx *= this._speed / distance;
      dy *= this._speed / distance;
    }

    //now move
    this.x += dx;
    this.y += dy;
  }
}

const Cursor: React.FunctionComponent = () => {
  let animate = true;

  const mouse = new Mouse();
  const _balls: Ball[] = [];

  const [balls, setBalls] = useState<Ball[]>([]);

  for (let ballIndex = 0; ballIndex < 5; ballIndex++){
    _balls.push(new Ball(24 + 4 * ballIndex, 0, 0));
  }

  const onMouseMove = ({ x, y }: MouseEvent): void => {
    mouse.setPosition(x, y);
  }

  const animationFrame = () => {
    requestAnimationFrame(() => {
      for (const ball of _balls) {
        ball.update(mouse);
      }

      setBalls([..._balls]);

      if (animate) {
        animationFrame();
      }
    })
  };

  React.useEffect(() => {
    window.addEventListener('mousemove', onMouseMove);
    animationFrame();

    return () => {
      animate = false;
      window.removeEventListener('mousemove', onMouseMove);
    };
  }, []);


  return (
    <div className={classNames(styles.component)}>
      {balls.map(
        (thisItem, thisItemIndex) => (
          <div
            key={thisItemIndex}
            className={classNames(styles.ball)}
            style={{
              top: thisItem?.y,
              left: thisItem?.x,
            }}
          />
        )
      )}
    </div>
  )
};

export default Cursor;
